<template>
	<div class="d-flex justify-end align-center order-0 order-sm-1"  style="min-width: 168px;gap:5px;">
		<v-menu offset-y :close-on-content-click="false"
			v-if="checkPermissions(['change_priority_task']) || checkPermissions(['change_critical_date_task'])">
			<template v-slot:activator="{ on: onMenu }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on: onTooltip }">
								<v-btn
									x-small
									class="topbar-action-btn"
									dark
									color="#5E85EF"
									v-on="{...onMenu, ...onTooltip}"
								>
									<v-icon dark small>mdi-clipboard-edit-outline</v-icon>
								</v-btn>
					</template>
					<span>Modificar Adicional</span>
				</v-tooltip>
			</template>
			<div style="background: white">
				<div class="bg-light-blue-text py-1 px-2">
					<p class="caption mb-0 font-weight-bold white--text">Modificar Adicional</p>
				</div>
				<div class="pa-2">
					<div>
						<p class="mt-2 mb-0 caption light-blue-text font-weight-bold">
							Estado Visualización
							<v-tooltip bottom max-width="400">
								<template v-slot:activator="{ on, attrs }">
									<v-icon color="#5E85EF"
										v-bind="attrs"
										v-on="on"
										small>mdi-information</v-icon>
								</template>
								<span>Maneja con que estado quieres ver la campana asociada a esta tarea.</span>
							</v-tooltip>
						</p>
						<div>
							<v-btn
								x-small
								class="mx-2 topbar-action-btn"
								color="success"
								:outlined="$options.filters.seenByMeColor(currentAdicional.seen_by_me) !== 'success'"
								:loading="isLoadingChangeVisualizationStatus(currentAdicional.id)"
								@click.stop="changeVisualizationStatus(1)"
							>
								<v-icon small>mdi-bell</v-icon>
							</v-btn>
							<v-btn
								x-small
								class="mx-2 topbar-action-btn"
								color="warning"
								:outlined="$options.filters.seenByMeColor(currentAdicional.seen_by_me) !== 'warning'"
								:loading="isLoadingChangeVisualizationStatus(currentAdicional.id)"
								@click.stop="changeVisualizationStatus(2)"
							>
								<v-icon small>mdi-bell</v-icon>
							</v-btn>
							<v-btn
								x-small
								class="mx-2 topbar-action-btn"
								color="high"
								:outlined="$options.filters.seenByMeColor(currentAdicional.seen_by_me) !== 'high'"
								:loading="isLoadingChangeVisualizationStatus(currentAdicional.id)"
								@click.stop="changeVisualizationStatus(0)"
							>
								<v-icon small>mdi-bell</v-icon>
							</v-btn>
						</div>
					</div>
					<div>
						<p class="mt-2 mb-0 caption light-blue-text font-weight-bold">
							Suscribir a Adicional
							<v-tooltip bottom max-width="400">
								<template v-slot:activator="{ on, attrs }">
									<v-icon color="#5E85EF"
										v-bind="attrs"
										v-on="on"
										small>mdi-information</v-icon>
								</template>
								<span>Si te suscribes a un Adicional recibirás notificaciones en tu correo cuando ocurran cambios importantes: Revisiones, Fechas, Cierre. </span>
							</v-tooltip>
						</p>
						<div>
							<v-switch
								class="my-0"
								dense
								v-model="editAdditionalForm.subscribe_status"
								@change="changeInSubscription"
								hide-details
							>
								<template slot="label">
									<p class="mb-0 caption">{{editAdditionalForm.subscribe_status ? 'Recibirás notificaciones':'No recibirás notificaciones'}}</p>
								</template>
							</v-switch>
							<v-switch
								class="my-0"
								dense
								v-model="editAdditionalForm.subscribe_status_mail"
								:disabled="!editAdditionalForm.subscribe_status"
								hide-details
							>
								<template slot="label">
									<p class="mb-0 caption">{{editAdditionalForm.subscribe_status_mail ? 'Recibirás correos de este Adicional':'No recibirás correos de este Adicional'}}</p>
								</template>
							</v-switch>
						</div>
					</div>
					<div>
						<p class="mt-2 mb-0 caption light-blue-text font-weight-bold">
							Recordatorio
							<v-tooltip bottom max-width="400">
								<template v-slot:activator="{ on, attrs }">
									<v-icon color="#5E85EF"
										v-bind="attrs"
										v-on="on"
										small>mdi-information</v-icon>
								</template>
								<span>Selecciona uno o más días de la semana en los que quieras que te recordemos esta tarea. Aparecerá un recordatorio al ingresar a tu panel LaOT.</span>
							</v-tooltip>
						</p>
						<div>
							<v-menu
								v-model="datePickerRemider"
								offset-y
								:close-on-content-click="false"
								max-width="290"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										dark
										small
										block
										color="#5E85EF"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small>mdi-clipboard-edit-outline</v-icon>
										<p class="mb-0 ml-2">Seleccionar Días</p>
									</v-btn>
								</template>
								<div class="grey lighten-4 pa-2">
									<v-btn
										v-for="(day, index) in weekDays"
										:key="index"
										dark
										x-small
										color="#5E85EF"
										:outlined="!isWeekDaySelected(index)"
										class="mx-1"
										@click="addWeekDay(index)"
									>
										<p class="mb-0">{{day}}</p>
									</v-btn>
									<v-switch
										class="my-1"
										dense
										v-model="editAdditionalForm.reminder_repeatable"
										:disabled="this.editAdditionalForm.reminder.length === 0"
										hide-details
									>
										<template slot="label">
											<p class="mb-0 caption">Recordar Semanalmente</p>
										</template>
									</v-switch>
									<p class="mb-1 caption text--secondary">Recuerda confirmar para que este recordatorio tome efecto</p>
								</div>
							</v-menu>
						</div>
					</div>
					<v-divider class="my-2"></v-divider>
					<v-btn
						class="mt-2"
						color="#2D4B95"
						raised
						small
						block
						dark
						:loading="loadingEdit"
						@click="() => modifyAdditional()"
					>
						<p class="mb-0 white--text">Confirmar</p>
					</v-btn>
				</div>
			</div>
		</v-menu>
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn class="topbar-action-btn" dark x-small color="#2D4B95"
							v-bind="attrs"
							v-on="on"
							@click="sendByEmailModal = true">
					<v-icon dark small>mdi-email</v-icon>
				</v-btn>
			</template>
			<span>Enviar por correo</span>
		</v-tooltip>
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn class="topbar-action-btn" dark x-small color="#2D4B95"
							v-bind="attrs"
							v-on="on"
							:loading="loadingPDFDownload"
							@click="downloadPDF">
					<v-icon dark small>mdi-file-pdf-box</v-icon>
				</v-btn>
			</template>
			<span>Descargar en PDF</span>
		</v-tooltip>
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-btn class="topbar-action-btn" dark x-small color="#2D4B95"
							v-bind="attrs"
							v-on="on"
							:loading="loadingFilePath"
							@click="downloadAttachments">
					<v-icon dark small>mdi-download</v-icon>
				</v-btn>
			</template>
			<span>Descargar Adjuntos</span>
		</v-tooltip>
		<v-btn class="topbar-action-btn" dark x-small color="#fb8c00" @click="minimizeAdditional">
			<v-icon dark small>mdi-window-minimize</v-icon>
		</v-btn>
		<CloseNotificationButton
			:notification="currentAdicional && currentAdicional.active_notification"
			:closeModal="closeModal"
		/>
		<v-btn class="topbar-action-btn" dark small color="#F4516C" @click="closeModal">
			<v-icon dark small>mdi-close</v-icon>
		</v-btn>
    <AcceptCancelModal :acceptRejectModal="acceptRejectModal" :acceptRejectModalData="acceptRejectModalData"
      :closeModal="closeModalAcceptCancel"/>
		<SendContentByEmailModal :sendContentByEmailModal="sendByEmailModal" :closeModal="() => sendByEmailModal = false" :sendingType="3"/>
	</div>
</template>

<script>
import {update, changeVisualizationStatus, getAdditionalPDF} from '@/helpers/api/additionals'
import {getZippedFilesByItem} from '@/helpers/api/fileUploads'
import {deleteRdi} from '@/helpers/api/rdi'
import SendContentByEmailModal from '@/components/Globals/Modals/General/SendContentByEmailModal'
import AcceptCancelModal from '@/components/Globals/Modals/General/AcceptCancelModal'
import CloseNotificationButton from '@/components/Globals/Modals/General/CloseNotificationButton'

export default {
	name: 'HeaderButtons',
	props: {
		closeModal: {
			type: Function,
			required: true
		},
		draftId: {
			type: Number,
			required: false,
			default: null
		}
	},
	components: { SendContentByEmailModal, AcceptCancelModal, CloseNotificationButton },
  computed: {
    currentAdicional() {
      return this.$store.adicionalesStore.state.currentAdicional
    }
  },
  watch: {
    currentAdicional() {
			this.setFormData()
    }
  },
  data: () => ({
		loadingFilePath: false,
		loadingEdit: false,
		datePicker: false,
		datePickerRemider: false,
		sendByEmailModal: false,
		loadingPDFDownload: false,
		acceptRejectModalData: null,
		acceptRejectModal: false,
		editAdditionalForm: {
			priority: null,
			critical_date: null,
			subscribe_status: false,
			subscribe_status_mail: false,
			reminder: [],
			reminder_repeatable: false
		},
		weekDays: ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo']
  }),
	mounted(){
		this.setFormData()
	},
	methods: {
		setFormData(){
			const additional = this.$store.adicionalesStore.state.currentAdicional
      if(additional && !additional.loading && additional.id){
				const additional = this.$store.adicionalesStore.state.currentAdicional
				this.editAdditionalForm.subscribe_status = !!additional.user_subscribed
				this.editAdditionalForm.subscribe_status_mail = additional.user_subscribed && additional.user_subscribed.email
				this.editAdditionalForm.reminder = additional.user_reminders.map((day) => day.day_number)
				this.editAdditionalForm.reminder_repeatable = additional.user_reminders.some((day) => day.repeatable)
      }
		},
		isMyRdi(){
      return this.$store.userStore.state.userInfo.id === this.$store.adicionalesStore.state.currentAdicional.created_by_user.id
		},
		iAmTaskResponsible(){
      return this.$store.consultasStore.state.currentTarea.responsable == this.$store.userStore.state.userInfo.id
		},
		changeInSubscription(value){
			this.editAdditionalForm.subscribe_status_mail = value
		},
		async modifyAdditional(){
			this.loadingEdit = true
			this.editAdditionalForm.id = this.$store.adicionalesStore.state.currentAdicional.id
			const additionalUpdate = await update(this.editAdditionalForm)
      if(additionalUpdate.code == 200){
        this.$store.adicionalesStore.commit('setCurrentAdicional', additionalUpdate.additional)
        this.getAdditionalList()
				const data = {
					message: 'Se ha modificado correctamente el Adicional',
					title: 'Adicional modificado',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.$store.globalStore.dispatch('addMessage', data)
				this.$store.notificationsStore.dispatch('getReminders')
      }
			this.loadingEdit = false
		},
    async getAdditionalList(){
      let project_id = null
      if(this.$store.projectsStore.state.selectedProject){
        project_id = this.$store.projectsStore.state.selectedProject.id
      }
      else{
        const id = localStorage.getItem('selectedProjectID')
        project_id = parseInt(id)
      }
      if(project_id){
        this.$store.adicionalesStore.dispatch('getRDI', {project_id})
				this.$store.adicionalesStore.dispatch('getAdditionals', { project_id })
      }
    },
    minimizeAdditional(){
      const data = {
        task_id: this.$store.adicionalesStore.state.currentAdicional.id,
        title: this.$store.adicionalesStore.state.currentAdicional.title,
        type: 'Adicional',
        type_id: 5,
        number: this.$store.adicionalesStore.state.currentAdicional.number,
				draft_id: this.draftId
      }
      this.$store.globalStore.commit('addTaskToTasksHandler', data)
      this.closeModal()
    },
		async downloadPDF(){
			this.loadingPDFDownload = true
			const pdf_url = await getAdditionalPDF({additional_id: this.$store.adicionalesStore.state.currentAdicional.id})
      if(pdf_url.code == 200){
          window.open(pdf_url.pdf_url);
      }
			this.loadingPDFDownload = false
		},
    startDeleteRdi(){
      this.acceptRejectModalData = {
        title: '¿Eliminar la RDI Nº ' + this.$store.adicionalesStore.state.currentAdicional.number + '?',
        content_a: 'Por favor confirma si deseas elliminar la RDI indicada.'
      }
      this.acceptRejectModal = true
    },
		async deleteRdi(){
			const task = await deleteRdi({rdi_id: this.$store.adicionalesStore.state.currentAdicional.id})
      if(task.code === 200){
        this.getRDIList()
				this.$store.adicionalesStore.commit('setcurrentAdicional', null)
				const data = {
					message: 'Se ha eliminado correctamente la RDI',
					title: 'RDI eliminada',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.$store.globalStore.dispatch('addMessage', data)
				this.$store.notificationsStore.dispatch('getReminders')
			}
		},
    closeModalAcceptCancel(status = false){
      this.acceptRejectModal = false
      if(status){
        this.deleteRdi()
      }
      this.acceptRejectModalData = null
    },
		addWeekDay(index){
			const found = this.editAdditionalForm.reminder.findIndex((itemReminder) => itemReminder === index)
			if(found !== -1){
				this.editAdditionalForm.reminder.splice(found, 1)
			}
			else{
				this.editAdditionalForm.reminder.push(index)
			}
			if(this.editAdditionalForm.reminder.length === 0){
				this.editAdditionalForm.reminder_repeatable = false
			}
		},
		isWeekDaySelected(index){
			return this.editAdditionalForm.reminder.includes(index)
		},
		async changeVisualizationStatus(newStatus){
			let additional = this.$store.adicionalesStore.state.currentAdicional
			if(!this.isLoadingChangeVisualizationStatus(additional.id)){
				this.$store.adicionalesStore.commit('addLoadingChangeVisualizationStatus', additional.id)
				const data = {
					additional_id: additional.id,
					status: newStatus
				}
				const statusUpdate = await changeVisualizationStatus(data)
				if(statusUpdate.code === 200){
					// Actualizo el estado de forma local para no tener que pedir todo de nuevo a la api por cada actualización de estado
					let newAdditionalData = Object.assign({}, additional)
					newAdditionalData.seen_by_me.seen_status = newStatus
					this.$store.adicionalesStore.dispatch('updateAdditionalLocally', newAdditionalData)
				}
				this.$store.adicionalesStore.commit('removeLoadingChangeVisualizationStatus', additional.id)
			}
		},
		isLoadingChangeVisualizationStatus(additionalID){
			const found = this.$store.adicionalesStore.state.loadingChangeVisualizationStatus.find((additional_id) => additional_id === additionalID)
			return !!found
		},
		async downloadAttachments(){
			this.loadingFilePath = true
			let additional = this.$store.adicionalesStore.state.currentAdicional
			if(!additional || !additional.id){ this.loadingFilePath = false; return }
			try{
				const files = await getZippedFilesByItem({ additional_id: additional.id })
				if(files && files.code == 200 && files.fileurl) window.open(files.fileurl)
				else if(files && files.job_id){
					const data = {
						message: 'La descarga se está preparando. Recibirás un correo con el enlace cuando esté lista.',
						title: 'Descarga de archivos',
						created: new Date(),
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.$store.globalStore.dispatch('addMessage', data)
				}
			} catch(e){ console.error(e) }
			this.loadingFilePath = false
		}
	}
}
</script>

<style scoped>
	.bg-light-blue-text{background-color: #5E85EF;}
	.icon-top{
		padding: 2px;
		margin: 0 2px;
		border-radius: 100%;
		width: 30px;
		height: 30px;
		cursor: pointer;
	}
	.icon-top.high{
		background-color: #F4516C;
	}
	.icon-top.medium{
		background-color: #fb8c00;
	}
	.icon-top.normal{
		background-color: #3EBFA3;
	}
	.icon-top.primary{
		background-color: #2D4B95;
	}
	.icon-top.light-blue{
		background-color: #5E85EF;
	}
	.high--text {
    color: #F4516C !important;
    caret-color: #F4516C !important;
	}
	.high{
    background-color: #F4516C !important;
    border-color: #F4516C !important;
		color: white;
	}
	.topbar-action-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 24px!important;
		padding: 5px!important;
		min-width: 28px!important;
		aspect-ratio: 1!important;
		border-radius: 6px;
		border: none;
		cursor: pointer;
		transition: opacity 0.15s;
	}
	.topbar-action-btn.big{
		height: 30px!important;
		min-width: 30px!important;
	}
</style>